import { useMemo } from 'react'
import { DateRangeSchema } from 'cms/schemaTypes/generalSchemas/dateRange'
import { ListItemWithAssetSchema } from 'cms/schemaTypes/staticPages/objects/listItemWithAsset'
import { TextItemSchema } from 'cms/schemaTypes/staticPages/objects/textItem'

import { urlFor } from 'lib/sanity/image'

import InfoFrame from '../components/InfoFrame'
import PrizeItem from '../components/PrizeItem'

import styles from './RewardsProgramProfileViewMain.module.scss'

interface RewardsProgramProfileViewMainProps {
  header: string
  frame1Text: TextItemSchema
  range: DateRangeSchema
  items: ListItemWithAssetSchema[]
}

const RewardsProgramProfileViewMain = ({
  frame1Text,
  range,
  items,
  header
}: RewardsProgramProfileViewMainProps) => {
  const prizeItems = useMemo(() => {
    return items.map(item => {
      const code = item.metadata?.code
      let metadata: Record<string, unknown> | null = null

      if (code) {
        try {
          metadata = JSON.parse(code) as Record<string, unknown>
        } catch {
          metadata = null
        }
      }

      return {
        image: {
          url: urlFor(item.image.asset?.asset).url(),
          alt: item.image.alt
        },
        textBtn: item.content || [],
        header: item.header,
        isSoldOut: Boolean(metadata?.isSoldOut),
        isDisabled: Boolean(metadata?.isBlocked)
      }
    })
  }, [items])

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{header}</h1>
      <InfoFrame
        className={styles.infoFrame}
        range={range} frame1Text={frame1Text} />
      <ul className={styles.itemsWrapper}>
        {prizeItems.map((item, index) => {
          return (
            <PrizeItem
              key={index}
              id={`prize-${index + 1}`}
              isDisabled={item.isDisabled}
              isSoldOut={item.isSoldOut}
              variant={'blocked'}
              image={item.image}
              textBtn={item.textBtn || []}
              header={item.header || ''}
            />
          )
        })}
      </ul>
    </div>
  )
}

export default RewardsProgramProfileViewMain
